import React, {
    ChangeEvent,
    HTMLInputAutoCompleteAttribute,
    HTMLInputTypeAttribute
} from "react";
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import { Mask, Options, withMask } from "use-mask-input";

import { Input } from "@/components/Form/Base/input.component";
import { getFieldValue } from "@/components/Form/RHF/Utils/form.helpers";

export type InputMask = {
    regex?: Options["regex"];
    mask: Mask;
    placeholder: Options["placeholder"];
    definitions?: Options["definitions"];
};

type MaskedInputPartialProps<T extends FieldValues> = {
    field: ControllerRenderProps<T, Path<T>>;
    inputMask: InputMask;
    onPaste?: React.ClipboardEventHandler<HTMLInputElement>;
    type?: HTMLInputTypeAttribute;
    placeholder?: string;
    autoComplete?: HTMLInputAutoCompleteAttribute;
    disabled?: boolean;
    isValid: boolean;
    isInvalid: boolean;
    isLoading?: boolean;
    onAutofill?: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const MaskedInput = <T extends FieldValues>({
    field,
    inputMask,
    onPaste,
    type = "text",
    placeholder,
    autoComplete,
    disabled,
    isValid,
    isInvalid,
    isLoading,
    onAutofill
}: MaskedInputPartialProps<T>) => {
    const { mask, ...maskOptions } = inputMask || {};

    return (
        <Input
            {...field}
            value={getFieldValue(field, !!isLoading, "")}
            onPaste={(e) => onPaste?.(e)}
            id={field.name}
            ref={(ref) => {
                withMask(mask, { ...maskOptions })(ref);
                field.ref(ref);
            }}
            className="prefixed-input__input"
            type={type}
            placeholder={mask ? "" : placeholder}
            autoComplete={autoComplete}
            valid={isValid}
            invalid={isInvalid}
            disabled={disabled}
            onAutofill={onAutofill}
        />
    );
};
